/**
 * 公共配置文件
 */
// const NODE_ENV = process.env.NODE_ENV || 'development';
// let apiUrl = "http://localhost:8801";
// if(NODE_ENV === 'preview'){
//     apiUrl="http://123.60.147.255:8801";
// }
 module.exports={
    environment:"build",                      //打包部署服务器的时候，请把environment换成build
    apiUrl:"https://kefu-system-socket.kaimanhua.com",       //打包部署服务器的时候，请把apiUrl的localhost换成你的ip,如http://12.34.56.78:8801,不要使用localhost
    chatGptKey:'xxxxxx___look___this___xxxxx',
}
